var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dot-container"},[_c('div',{staticClass:"dots",class:`dots--${_vm.dotsStyle}`},[_c('div',{staticClass:"dot"}),_vm._v(" "),_c('div',{staticClass:"dot"}),_vm._v(" "),_c('div',{staticClass:"dot"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }